export const GET_PRODUCTS = 'providers/menuMaker/MenuMakerProducts/GET_PRODUCTS';
export const CREATE_PRODUCT = 'providers/menuMaker/MenuMakerProducts/CREATE_PRODUCT';
export const TOGGLE_PRODUCT_AVAILABILITY = 'providers/menuMaker/MenuMakerProducts/TOGGLE_PRODUCT_AVAILABILITY';
export const DUPLICATE_PRODUCT = 'providers/menuMaker/MenuMakerProducts/DUPLICATE_PRODUCT';
export const DELETE_PRODUCT = 'providers/menuMaker/MenuMakerProducts/DELETE_PRODUCT';
export const UPDATE_PRODUCT_IMAGE = 'providers/menuMaker/MenuMakerProducts/UPDATE_PRODUCT_IMAGE';
export const GET_PRODUCTS_SCROLL_PAGINATION = 'providers/menuMaker/MenuMakerProducts/GET_PRODUCTS_SCROLL_PAGINATION';
